import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'

import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import theme from 'ui/styles/theme'
import easing from 'ui/styles/easing'

//Error appears because video is loaded and the loader image is still below
//image should be displayed only when the video is not loaded and on mobile
// Video shouldnt be visible on mobile because hover doesn't work on mobile lol

export default class Product extends Component {
  constructor(props) {
    super(props)

    this.rewindInterval = null

    this.playVideo = this.playVideo.bind(this)
    this.rewindVideo = this.rewindVideo.bind(this)
    this.videoReady = this.videoReady.bind(this)

    this.video = React.createRef()
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    video: PropTypes.string,
    image: PropTypes.string,
    noMargin: PropTypes.bool,
    showOverlay: PropTypes.bool,
    overlayColor: PropTypes.string,
    overlayOpacity: PropTypes.number
  }

  static defaultProps = {
    video: '',
    image: '',
    noMargin: false,
    showOverlay: false,
    overlayColor: null,
    overlayOpacity: null
  }

  state = {
    ready: false,
    isMobile: false
  }
  componentDidMount() {
    this.detectMobile()
  }

  componentWillUnmount() {
    clearInterval(this.rewindInterval)
  }

  playVideo() {
    const { ready } = this.state
    const { current } = this.video

    if (ready && current) {
      current.play()
    }
  }

  rewindVideo() {
    const { ready } = this.state
    const { current } = this.video

    if (ready && current) {
      current.pause()

      this.rewindInterval = setInterval(() => {
        current.currentTime -= 0.03

        if (!current.currentTime) {
          clearInterval(this.rewindInterval)
        }

      }, 33)
    }
  }

  detectMobile = () => {
    const width = window.innerWidth
    const isMobile = width <= theme.grid.breakpoints.md

    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile })
    }
  }

  videoReady() {
    const { ready } = this.state

    if (!ready) {
      this.setState({ ready: true })
    }
  }

  render() {
    const {
      title,
      video,
      image,
      link,
      noMargin,
      showOverlay,
      overlayColor,
      overlayOpacity
    } = this.props

    const { ready, isMobile } = this.state

    return (
      <Link to={getRelativeUrl(link)}>
        <ProductContainer noMargin={noMargin}>
          <ProductName showOverlay={showOverlay}>{title}</ProductName>
          {showOverlay &&
            <Overlay
              overlayColor={overlayColor}
              overlayOpacity={overlayOpacity}
            />
          }
          {!isMobile &&
            <Video
              ready={ready}
              playsInline
              muted
              innerRef={this.video}
              src={video}
              onMouseEnter={() => this.playVideo()}
              onMouseLeave={() => this.rewindVideo()}
              onCanPlayThrough={() => this.videoReady()}
            />
          }
          {!ready &&
            <Loader image={image}>
              {!image &&
                <span>Loading...</span>
              }
            </Loader>
          }
          {isMobile &&
            <Loader image={image}/>
          }
        </ProductContainer>
      </Link>
    )
  }
}

// Styles
const ProductContainer = styled.div`
  margin: ${props => props.noMargin ? '' : '0 20px 20px'};
  position: relative;
  height: 0;
  padding-bottom: 100%;

  ${media.sm`
    margin: ${props => props.noMargin ? '' : '0 0 35px'};
  `}
`

const ProductName = styled.p`
  color: ${theme.colors.tones.darker};
  font-size: 20px;
  font-weight: 300;
  left: 25px;
  position: absolute;
  top: 22px;
  z-index: 3;
  margin-bottom: 5px;

  ${media.xs`
    ${props => !props.showOverlay ? 'position: relative; top: 0; left: 0;' : 'top: 5px;'};
  `}
`

const Video = styled.video`
  width: 100%;
  display: block;
  transition: opacity 0.5s ${easing.easeOutCubic};
  opacity: ${props => props.ready ? 1 : 0};
  position: relative;
  z-index: 2;
`

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background: ${props => props.overlayColor ? props.overlayColor : theme.colors.tones.lighter};
  opacity: ${props => props.overlayOpacity};
  pointer-events: none;
`

const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background: url(${props => props.image}) no-repeat center / cover;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/Products/Product.js